<template>
<moo-popover popper-class="common-popper create-popper" placement="bottom-end" width="160" trigger="hover" :close-delay="0" v-model="uploadVisible" :disabled="isRead">
    <moo-tooltip :content="toolTip" effect="light" :visible-arrow="false" popper-class="upload-tooltip-class" placement="left-start" :disabled="!(toolTip && toolTip.length > 0)">
      <div class="create-file-popper">
        <span :class="{ 'upload-tip': data.type === 'UPLOAD' }" @click="(event) => handleUpload(data.type)" :key="data?.icon" v-for="data in uploadOptions">
          <div class="create-tip">
            <svg-icon class-name="file-icon" :icon-class="data.icon"></svg-icon>
            {{ data?.name }}
          </div>
        </span>
      </div>
    </moo-tooltip>
        <div :class="{ 'common-btn': true, 'disabled-btn': isRead }" slot="reference">
            <moo-tooltip :content="$t('权限不足，无法上传/新建#!!!#src/pages/H5/Cloud/components/popper/UploadPopper.vue_1')" effect="light" :visible-arrow="false" popper-class="no-auth-tooltip-class" placement="bottom" :disabled="isRead === false">
            <div class="upload-content">{{$t("上传#!!!#src/pages/H5/Cloud/components/popper/UploadPopper.vue_1")}}                <svg-icon icon-class="file-upload-down" class="download-btn-icon"></svg-icon>
            </div>
            </moo-tooltip>
        </div>
  </moo-popover>
</template>

<script>
import { intl } from 'tci18n-vue2'
export default {
  props: {
    isRead: {
      type: Boolean,
      default: false
    },
    toolTip: {
      type: String,
      default: ""
    }
  },
  name: "UploadPopper",
  components: {},
  data() {
    return {
      uploadVisible: false,
      uploadOptions: [
      {
        name: intl.$t("上传文件#!!!#src/pages/H5/Cloud/components/popper/UploadPopper.vue_1"),
        icon: "file-upload",
        type: "file"
      },
      {
        name: intl.$t("上传文件夹#!!!#src/pages/H5/Cloud/components/popper/UploadPopper.vue_1"),
        icon: "folder-upload",
        type: "folder"
      }]

    };
  },
  methods: {
    handleUpload(value) {
      this.$emit("handleUpload", value);
      this.uploadVisible = false;
    }
  },
  computed: {
    createOptions() {
      if (this.isHeader) {
        return this.headerAdd;
      }
      return this.headerAdd.filter((item) => item.type !== "UPLOAD");
    }
  },
  watch: {},
  mounted() {},
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.common-popper {
  width: 146px !important;
  padding: 4px 4px !important;
  height: 112px;
  background: #ffffff;
  border: 1px solid #e6e8ec !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;
  box-sizing: border-box;
  height: auto !important;
  width: 146px !important;
  margin-top: 8px !important;

  .popper__arrow {
    display: none !important;
  }
}

.common-popper.create-popper {
  width: 180px !important;
  margin-top: 8px !important;
}

.header-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  width: 16px !important;
  height: 16px !important;
}

.header-icon:hover {
  background: #f4f6f9;
  border-radius: 4px;
}

.common-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 26px;
  background-color: #5c70ff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  font-family: PingFangSC-Regular;
  color: #ffffff;

  .download-btn-icon {
    width: 12px;
    height: 12px;
    margin-left: 4px;
  }

  &:hover {
    background-color: #6d7dff;
  }

  .upload-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.disabled-btn {
  background: #ced5fe !important;
  user-select: none;
  position: relative;

  .no-auth {
    display: none;
    position: absolute;
    bottom: -48px;
    right: -2px;
    line-height: 33px;
    text-align: center;
    width: 170px;
    height: 33px;
    background: #ffffff;
    border: 1px solid #e8e9ee;
    box-shadow: 0 8px 16px 0 #1213171a;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 12px;
    color: #121317;
  }
}

.disabled-btn:hover {
  .no-auth {
    display: block;
  }
}

.create-file-popper {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-end;

  .upload-popper {
    display: none;
    position: absolute;
    width: 170px;
    height: auto;
    left: -160px;
    top: 0;
    background: #ffffff;
    border: 1px solid #e6e8ec;
    box-shadow: 0 8px 12px 0 #1213171a;
    border-radius: 8px;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    padding: 4px;

    span {
      justify-content: flex-start;

      &:hover {
        background: #f4f6f9;
      }
    }

    &:hover {
      display: flex;
    }
  }

  .upload-tip {
    width: 200px;
  }

  .upload-tip:hover {
    .upload-popper {
      display: flex;
    }
  }

  span {
    font-weight: 400;
    font-size: 14px;
    color: #222329;
    letter-spacing: 0;
    width: 100%;
    height: 40px;
    border-radius: 8px;
    line-height: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    position: relative;

    .create-tip {
      width: 170px;
      height: 100%;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-radius: 8px;

      &:hover {
        background: #f4f6f9;
      }
    }

    .file-icon {
      cursor: pointer;
      width: 24px;
      height: 24px;
      margin: 0 8px;
    }

    .upload-file {
      width: 16px;
      height: 16px;
      margin: 0 8px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 8px;
      margin: auto 0;
    }
  }
}
</style>

<style lang="scss">
.upload-tooltip-class {
  width: 200px;
  border-radius: 8px !important;
  color: #767c85;
  font-size: 14px !important;
  font-weight: 400;
  padding: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border: none !important;
  line-height: 24px !important;
  margin-top: -4px !important;
  word-break: keep-all !important;
}

.no-auth-tooltip-class {
    border-radius: 8px !important;
    color: #767c85;
    font-size: 14px !important;
    font-weight: 400;
    padding: 8px !important;
    background-color: #fff !important;
    box-shadow: 0 8px 12px 0 #1213171a !important;
    border: none !important;
    line-height: 24px !important;
    margin-top: 18px !important;
    word-break: keep-all !important;
    text-align: center !important;
}
</style>
